export default __webpack_public_path__ + "media/writing-on-paper-6988.df19b05f.mp3";